import CheckboxMenuItem from '@components/v2/ui/Menu/CheckboxMenuItem';
import { AutocompleteRenderOptionState, MenuItem as MuiMenuItem } from '@mui/material';
import { HTMLAttributes } from 'react';

interface Props<T> {
  props: HTMLAttributes<HTMLLIElement> & { key?: React.Key };
  option: T;
  state: AutocompleteRenderOptionState;
  getOptionLabel: (option: T) => string;
  multiple?: boolean;
}

function AutocompleteOption<T>({ props, option, state, getOptionLabel, multiple }: Props<T>) {
  const { key, ...optionProps } = props;

  if (multiple) {
    return (
      <CheckboxMenuItem {...optionProps} key={key} selected={state.selected}>
        {getOptionLabel(option)}
      </CheckboxMenuItem>
    );
  }

  return (
    <MuiMenuItem {...optionProps} key={key} selected={state.selected}>
      {getOptionLabel(option)}
    </MuiMenuItem>
  );
}

export default AutocompleteOption;
